import React, { useState, useId } from 'react';
import * as PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { FieldsetControl, RadioControl, Container } from '@si-armes/dsfr-react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import BoutonEtape from 'components/form/boutonsEtape/BoutonEtape';
import RoutesRatelier from '../../../../ratelier/routes';
import { getPath } from '../../../../../../utils/router';

const SignalerErreurEtape1 = ({ etapeSuivante, resetSignalerArmeData, signalerArmeData }) => {
    const { isLoading } = useSelector((state) => state.armes.signalerErreur.recuperer);

    const { handleSubmit, register, watch, setValue } = useForm({
        mode: 'onChange',
    });
    const history = useHistory();
    const [disabledButton, setDisabledButton] = useState(true);

    const onSubmit = (dataForm) => {
        if (dataForm) {
            if (disabledButton === false) {
                resetSignalerArmeData(watch('erreurArme'));
            }
            etapeSuivante();
        }
    };

    if (disabledButton && signalerArmeData.typeErreur) {
        setValue('erreurArme', signalerArmeData.typeErreur);
        setDisabledButton(false);
    }

    const handleOnChange = () => {
        setDisabledButton(false);
    };

    return (
        <Container fluid={false}>
            <form onSubmit={handleSubmit(onSubmit)} onChange={handleOnChange}>
                <FieldsetControl
                    id="selectionErreur"
                    legend="Veuillez sélectionner le type d'erreur"
                    inline
                >
                    <RadioControl
                        id={useId()}
                        label="Je ne possède pas ou je ne possède plus cette arme"
                        value="non-possession"
                        {...register('erreurArme')}
                        disabled={isLoading}
                        onChange={handleOnChange}
                    />
                    <RadioControl
                        id={useId()}
                        label="Les informations de mon arme sont incorrectes"
                        value="information-incorrectes"
                        {...register('erreurArme')}
                        disabled={isLoading}
                        onChange={handleOnChange}
                    />
                </FieldsetControl>
                <BoutonEtape
                    nameBtnSuivant="etapeSuivante"
                    labelBtnSuivant="Étape suivante"
                    labelBtnPrecedent="Annuler"
                    actionPrecedente={() => {
                        history.push(getPath(RoutesRatelier));
                    }}
                    btnSuivantDisabled={disabledButton}
                />
            </form>
        </Container>
    );
};

SignalerErreurEtape1.propTypes = {
    etapeSuivante: PropTypes.bool.isRequired,
    resetSignalerArmeData: PropTypes.func.isRequired,
    signalerArmeData: PropTypes.shape({
        uuidArme: PropTypes.string.isRequired,
        typeErreur: PropTypes.string,
    }).isRequired,
};

export default SignalerErreurEtape1;
